import React, {Component} from 'react';
import Styles from './style.css';
import HeaderSignupTwo from "../../components/header-signup-two/component";
import cx from "classnames";
import '../../App.css';
import {langRegister} from "../../services/langRegister";
import {cartRegister} from "../../services/cartRegister";
import ReactGA from "react-ga";
import ReactGA4 from 'react-ga4';
import ReactPixel from "react-facebook-pixel";
import Basket from "../../components/basket/component";
import {dataRegister} from "../../services/dataRegister";
import {salesChannelRegister} from "../../services/salesChannelRegister";
import ErrorHandler from "../../components/error-handler/component";
import {userRegister} from "../../services/userRegister";
import queryString from "query-string";
import countryCodes from "country-telephone-data";
import AnimateHeight from 'react-animate-height';
import BoosterHeaderSecond from "../../components/booster-header-second/component";
import {tokenRegister} from "../../services/tokenRegister";

class BoosterCheckout extends Component {

    constructor(props) {
        super(props);
        this.state = {
            vat: 0,
            duration: 0,
            accordions: {one: 0, two: 0},
            lockin_plan: {},
            tab: "expect",
            promo_phone: "",
            promo_phone_2: "",
            search: "",
            search_2: "",
            industry: null,
            market: null,
            channels: null,
            language: null,
            service_fee_fixed: null,
            service_fee_percentage: null,
            currency: null,
            lockin: false,
            whatsapp: false,
            whatsapp_2: false,
            related: [],
            regions: [],
            targets: [],
            age_range: [],
            lockin_plans: [],
            countries: [],
            ad_languages: [],
            interests: [],
            behaviors: [],
            extra_industries: [],
            keyword_languages: [],
            error: false,
            reseller: false,
            private: false
        }
    };

    componentDidMount() {
        let token = tokenRegister.getToken();
        if(!token){
            this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang());
        }
    }

    componentWillMount() {
        window.scrollTo(0, 0);
        this._updateData();
        this._updateUser();
        this._updateCountries();

        //GOOGLE ANALYTICS
        if (dataRegister.api.primehit !== "https://api.devprimehit.com/v1") {
            ReactGA.pageview('/booster/checkout');
        }

        //FACEBOOK PIXEL
        if(dataRegister.api.primehit !== "https://api.devprimehit.com/v1"){
            ReactPixel.pageView();
        }

    }

    _updateUser() {
        try {
            let user = userRegister.get();
            if (user) {
                this.setState({
                    reseller: user.reseller,
                    inhouse: user.inhouse,
                    user_id: user.user_id,
                    profile_image: user.profile_image ? user.profile_image : ""
                });
            }
        } catch (e) {
        }
    }

    _updateData() {
        let stored_data = cartRegister.get();
        if (stored_data.admin_image) {
            if (!stored_data.admin_image.web_url) {
                this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/images");
            }
        }
        if (stored_data.smart_spend) {
                this.setState({
                    smart_spend: stored_data.smart_spend
                });
            //console.log(stored_data.smart_spend + " SMART SPEND");
        }
        if (stored_data.budget && stored_data.regions && stored_data.industry && stored_data.channels && (stored_data.image || stored_data.admin_image) && (stored_data.quotes || stored_data.admin_quotes) && stored_data.plan) {
            if (stored_data.regions.length < 1) {
                this.setState({error: true});
            } else {
                this.setState({
                    industry: stored_data.industry,
                    market: salesChannelRegister.get('market'),
                    currency: salesChannelRegister.get('currency'),
                    vat: salesChannelRegister.get('vat'),
                    ad_languages: JSON.parse(salesChannelRegister.get('ad_languages')),
                    private: salesChannelRegister.get('private'),
                    language: stored_data.language ? stored_data.language : salesChannelRegister.get('default_ad_language'),
                    keyword_languages: stored_data.keyword_languages ? stored_data.keyword_languages : [],
                    budget: stored_data.budget,
                    channels: stored_data.channels,
                    duration: stored_data.duration,
                    options: stored_data.options === "instant" ? 2 : 1,
                    related: stored_data.related_industries ? stored_data.related_industries : [],
                    plan: stored_data.plan,
                    targets: stored_data.targets ? stored_data.targets : [],
                    age_range: stored_data.age_range ? stored_data.age_range : [],
                    interests: stored_data.interests ? stored_data.interests : [],
                    behaviors: stored_data.behaviors ? stored_data.behaviors : [],
                    target_slogans: stored_data.target_slogans ? stored_data.target_slogans : [],
                    extra_industries: stored_data.selected_industries ? stored_data.selected_industries : [],
                    lockin: stored_data.lockin,
                    lockin_plan: stored_data.lockin_plan,
                    lockin_plans: stored_data.lockin_plans ? stored_data.lockin_plans : [],
                    regions: stored_data.regions ? stored_data.regions : [],
                    service_fee_percentage: stored_data.servicefee_percentage === 0 ? null : stored_data.servicefee_percentage,
                    service_fee_fixed: stored_data.servicefee_fixed === 0 ? null : stored_data.servicefee_fixed
                });
            }
        } else {
            this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/images");
        }
    }

    _updateCountries() {
        let countries = JSON.parse(JSON.stringify(countryCodes.allCountries));
        for (let i = 0; i < countries.length; i++) {
            countries[i].dialCode = "+" + countries[i].dialCode;
            if (countries[i].iso2 === salesChannelRegister.get('market')) {
                this._selectCountry(countries[i]);
            }
        }
        this.setState({countries: countries});
    }

    _payment() {
        this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/payment");
    }

    _promopage(personal) {
        if (this._renderPromoPage()) {
            let cart = JSON.parse(JSON.stringify(cartRegister.get()));
            let url_object = {
                duration: cart.duration,
                image: JSON.stringify({url: cart.image.url, id: cart.image.id}),
                industry: JSON.stringify(cart.industry),
                facebook_demographics: JSON.stringify({
                    age_range: cart.age_range,
                    targets: cart.targets,
                    interests: cart.interests ? cart.interests : [],
                    behaviors: cart.behaviors ? cart.behaviors : []
                }),
                channels: JSON.stringify(Object.keys(cart.channels).filter((key) => {
                    return cart.channels[key].selected
                })),
                related_industries: JSON.stringify(cart.related_industries.filter((item) => {
                    return item.selected
                }).concat(this.state.extra_industries).map((item) => {
                    delete item.selected;
                    return (item)
                })),
                slogans: JSON.stringify(Object.keys(cart.quotes).filter((key) => {
                    return cart.quotes[key].selected
                }).map((key) => {
                    return {
                        id: cart.quotes[key].id,
                        slogan: cart.quotes[key].slogan,
                        index: cart.quotes[key].index,
                        custom: cart.quotes[key].custom
                    }
                })),
                //crossroad: cart.crossroad === "instant"?2:1,
                options: cart.options === "instant" ? 2 : 1,
                regions: JSON.stringify(cart.regions),
                currency: this.state.currency,
                user_id: this.state.user_id ? this.state.user_id : null,
                vat: this.state.vat,
                lang: langRegister.lang(),
                language: cart.language ? cart.language : salesChannelRegister.get('default_ad_language'),
                phone: (this.state.country.dialCode && this.state.promo_phone !== "") ? (this.state.country.dialCode + this.state.promo_phone) : "",
                whatsapp: this.state.whatsapp
            };
            if (cart.target_slogans) {
                try {
                    url_object.target_slogan = cart.target_slogans.filter((item) => {
                        return item.selected
                    })[0].id;
                } catch (e) {
                }
            }
            if (personal) {
                url_object.profile_image = this.state.profile_image;
                url_object.personal = true;
                url_object.whatsapp = this.state.whatsapp_2;
                url_object.phone = (this.state.country.dialCode && this.state.promo_phone_2 !== "") ? (this.state.country.dialCode + this.state.promo_phone_2) : "";
                url_object.seller_name = this.state.seller_name;
                url_object.job_title = this.state.job_title;
            }
            let query = queryString.stringify(url_object);
            window.open("https://promo." + dataRegister.getDomain() + "/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "?" + query, '_blank');
        }
    }

    _selectTab(option) {
        this.setState({tab: option});
    }

    _toggleLockin() {
        this.setState({lockin: !this.state.lockin}, () => {
            cartRegister.setLockin(this.state.lockin);
            cartRegister.setAdLockinPlan(this.state.lockin_plan);
        });
    }

    _selectLockinPlan(plan) {
        this.setState({lockin_plan: JSON.parse(plan)}, () => {
            if (this.state.lockin) {
                cartRegister.setLockin(this.state.lockin);
                cartRegister.setAdLockinPlan(this.state.lockin_plan);
            }
        });
    }

    _selectCountry(option) {
        this.setState({country: option, search: option.dialCode});
    }

    _terms() {
        window.open('https://legal.' + dataRegister.domain + "/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/terms/" + salesChannelRegister.get('name'), '_blank');
    }

    _renderAdLanguage() {
        for (let i = 0; i < this.state.ad_languages.length; i++) {
            if (this.state.ad_languages[i].value === this.state.language) {
                return (this.state.ad_languages[i].title[langRegister.lang()])
            }
        }
    }

    _renderPromoPage() {
        let cart = cartRegister.get();
        return false; //this.state.reseller && !cart.admin_image && !cart.admin_quotes && !this.state.private;
    }

    _renderImpressionsBySpend() {
        let impressions = 0;
        if (this.state.budget) {
            for (let key in this.state.channels) {
                if (this.state.channels[key].selected) {
                    impressions = impressions + (this.state.budget[key].spend / this.state.budget[key].cpi);
                }
            }
            return Math.ceil(impressions);
        } else {
            return ("...");
        }
    }

    _renderLeadsBySpend() {
        let clicks = 0;
        if (this.state.budget) {
            for (let key in this.state.channels) {
                if (this.state.channels[key].selected) {
                    clicks = clicks + (this.state.budget[key].spend / this.state.budget[key].cpc);
                }
            }
            return Math.ceil(clicks);
        } else {
            return ("...");
        }
    }

    _renderPartialBudget() {
        if (this.state.budget && this.state.channels) {
            let budget = 0;
            for (let key in this.state.budget) {
                if (this.state.budget[key] && this.state.channels[key].selected) {
                    budget = budget + this.state.budget[key].spend;
                }
            }

            // IF FIXED FEE
            if (this.state.service_fee_fixed) {
                budget = budget + this._renderFixedFee();
            }

            //IF PERCENTAGE SERVICE FEE
            if (this.state.service_fee_percentage) {
                budget = budget + this._renderPercentageFee();
            }

            //IF COMMISSION
            if (!this.state.service_fee_percentage && !this.state.service_fee_fixed && this.state.lockin) {
                budget = budget * this.state.lockin_plan.months;
            }

            //IF LOCKIN
            if (this.state.lockin) {
                budget = budget - this._renderDiscount();
            }

            //IF VAT
            if (this.state.vat) {
                budget = budget + this._renderVat();
            }

            return budget;
        }
    }

    _renderTotalBudget() {
        let budget = 0;
        for (let key in this.state.budget) {
            if (this.state.budget[key] && this.state.channels[key].selected) {
                budget = budget + this.state.budget[key].spend;
            }
        }
        return this._renderNumbers(Math.round(budget));
    }

    _renderFixedFee() {
        if (this.state.lockin && this.state.lockin_plan) {
            return this.state.service_fee_fixed * this.state.lockin_plan.months;
        } else {
            return this.state.service_fee_fixed
        }
    }

    _renderPercentageFee() {
        if (this.state.budget && this.state.channels) {
            let budget = 0;
            for (let key in this.state.budget) {
                if (this.state.budget[key] && this.state.channels[key].selected) {
                    budget = budget + this.state.budget[key].spend;
                }
            }
            if (this.state.lockin && this.state.lockin_plan) {
                return (budget * (this.state.service_fee_percentage / 100)) * this.state.lockin_plan.months;
            } else {
                return budget * (this.state.service_fee_percentage / 100);
            }
        }
    }

    _renderDiscount() {
        if (this.state.lockin_plan) {
            let budget = 0;
            for (let key in this.state.budget) {
                if (this.state.budget[key] && this.state.channels[key].selected) {
                    budget = budget + this.state.budget[key].spend;
                }
            }
            if (this.state.service_fee_fixed) {
                return this.state.service_fee_fixed * this.state.lockin_plan.free_months;
            }
            else if (this.state.service_fee_percentage) {
                return (budget * (this.state.service_fee_percentage / 100)) * this.state.lockin_plan.free_months;
            } else {
                return budget * this.state.lockin_plan.free_months;
            }
        }
    }

    renderKeywordLanguageTitle(item) {
        let items = {
            'en': {'en': 'English', 'sv': 'Engelska'},
            'ar': {'en': 'Arabic', 'sv': 'Arabiska'},
            'fi': {'en': 'Finnish', 'sv': 'Finska'},
            'de': {'en': 'German', 'sv': 'Tyska'},
            'zh': {'en': 'Chinese', 'sv': 'Kinesiska'},
            'tr': {'en': 'Turkish', 'sv': 'Turkiska'},
            'es': {'en': 'Spanish', 'sv': 'Spanska'},
            'el': {'en': 'Greek', 'sv': 'Grekiska'},
            'sv': {'en': 'Swedish', 'sv': 'Svenska'},
            'cs': {'en': 'Czech', 'sv': 'Tjeckiska'},
            'da': {'en': 'Danish', 'sv': 'Danska'},
            'mt': {'en': 'Maltese', 'sv': 'Maltesiska'},
            'hr': {'en': 'Croatian', 'sv': 'Kroatiska'},
            'pa': {'en': 'Punjabi', 'sv': 'Punjabi'},
            'fr': {'en': 'French', 'sv': 'Franska'},
            'nl': {'en': 'Dutch', 'sv': 'Holländska'},
            'ko': {'en': 'Korean', 'sv': 'Koreanska'},
            'hi': {'en': 'Hindi', 'sv': 'Hindi'},
            'pt': {'en': 'Portuguese', 'sv': 'Portugisiska'},
            'ur': {'en': 'Urdu', 'sv': 'Urdu'},
            'it': {'en': 'Italian', 'sv': 'Italienska'},
            'ru': {'en': 'Russian', 'sv': 'Ryska'},
            'pl': {'en': 'Polish', 'sv': 'Polska'},
            'ja': {'en': 'Japanese', 'sv': 'Japanska'},
            'sr': {'en': 'Serbian', 'sv': 'Serbiska'},
            'ms': {'en': 'Malay', 'sv': 'Malay'}
        };
        try {
            return items[item][langRegister.lang()];
        } catch (e) {
            return item;
        }
    }

    _renderVat() {
        if (this.state.budget && this.state.channels) {
            let budget = 0;
            for (let key in this.state.budget) {
                if (this.state.budget[key] && this.state.channels[key].selected) {
                    budget = budget + this.state.budget[key].spend;
                }
            }

            // IF FIXED FEE
            if (this.state.service_fee_fixed) {
                budget = budget + this._renderFixedFee();
            }

            //IF PERCENTAGE SERVICE FEE
            if (this.state.service_fee_percentage) {
                budget = budget + this._renderPercentageFee();
            }

            //IF COMMISSION
            if (!this.state.service_fee_percentage && !this.state.service_fee_fixed && this.state.lockin) {
                budget = budget * this.state.lockin_plan.months;
            }

            //IF LOCKIN
            if (this.state.lockin) {
                budget = budget - this._renderDiscount();
            }

            return budget * (+this.state.vat / 100);
        }
    }

    _renderSelectedChannels() {
        let selected = false;
        for (let key in this.state.channels) {
            if (this.state.channels[key].selected) {
                selected = true;
            }
        }
        return selected;
    }

    _renderNumbers(x) {
        try {
            x = Math.round(x * 100) / 100;
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
        } catch (e) {
            return ("...")
        }
    }

    _renderChannelName(item) {
        if (item === "facebook") {
            return "Facebook social"
        } else if (item === "instagram") {
            return "Instagram social"
        } else if (item === "google") {
            return "Google search"
        } else if (item === "bing") {
            return "Bing search"
        }
    }

    _renderName(item) {
        try {
            if (salesChannelRegister.get('default_language') !== langRegister.lang() && item.internationalname) {
                return item.internationalname;
            } else {
                return item.name
            }
        } catch (e) {
            return item.name
        }
    }

    _renderText(item) {
        return langRegister.get("signup-checkout", item);
    }

    render() {
        return (
            <div>
                <BoosterHeaderSecond history={this.props.history} props={this.props} step={4}/>
                {
                    this.state.regions && this.state.plan && !this.state.error &&
                    <div className={Styles.containerOuter}>
                        <div className={Styles.container}>
                            <div style={salesChannelRegister.get('name')==='yieldlock'?{color: '#00273A'}:{}} className={Styles.title}>
                            <span style={salesChannelRegister.get('name')==='yieldlock'?{color: '#00273A'}:{}}
                                className={Styles.titleBold}>{this._renderText("item_1")}</span>{this._renderText("item_2")}
                            </div>
                            <div className={Styles.containerInner}>
                                <div className={Styles.left}>
                                    {
                                        false &&
                                        <img className={Styles.bubbleLeft}
                                             src={require("../../assets/images/bubble_left.png")}/>
                                    }
                                    {
                                        false &&
                                        <div className={Styles.bubbleLeftText}>
                                            {this._renderText("item_46")}
                                        </div>
                                    }
                                    {
                                        false &&
                                        <img className={Styles.bubbleRight}
                                             src={require("../../assets/images/bubble_right.png")}/>
                                    }
                                    {
                                        false &&
                                        <div className={Styles.bubbleRightText}>
                                            {
                                                (this.state.service_fee_fixed || this.state.service_fee_percentage) &&
                                                <span>
                                            {this._renderText("item_61")}
                                        </span>
                                            }
                                            {
                                                (!this.state.service_fee_fixed && !this.state.service_fee_percentage) &&
                                                <span>
                                            {this._renderText("item_62")}
                                        </span>
                                            }
                                        </div>
                                    }
                                    {
                                        false &&
                                        <div className={Styles.optionContainer}>
                                            <div className={Styles.optionContainerInner}>
                                                <div className={Styles.optionContainerInnerLeft}>
                                                    <div className={Styles.optionContainerInnerLeftTitle}>
                                                        {this._renderText("item_5")}
                                                    </div>
                                                    <div className={Styles.optionContainerInnerLeftSubtitle}>
                                                        {this._renderText("item_6")}
                                                    </div>
                                                </div>
                                                <div className={Styles.optionContainerInnerCenter}>
                                                    {
                                                        !this.state.lockin &&
                                                        <img onClick={() => this._toggleLockin()}
                                                             className={Styles.optionContainerInnerCenterSlider}
                                                             src={require("../../assets/images/push_black_off.svg")}/>
                                                    }
                                                    {
                                                        this.state.lockin &&
                                                        <img onClick={() => this._toggleLockin()}
                                                             className={Styles.optionContainerInnerCenterSlider}
                                                             src={require("../../assets/images/slider_active.svg")}/>
                                                    }
                                                </div>
                                                <div className={Styles.optionContainerInnerRight}>
                                                    <div className={Styles.optionContainerInnerRightTitle}>
                                                        <select className={Styles.optionContainerInnerRightTitleDropdown}
                                                                value={JSON.stringify({
                                                                    months: this.state.lockin_plan ? this.state.lockin_plan.months : "",
                                                                    free_months: this.state.lockin_plan ? this.state.lockin_plan.free_months : ""
                                                                })}
                                                                onChange={(event) => this._selectLockinPlan(event.target.value)}>
                                                            {
                                                                this.state.lockin_plans.map((item, i) => {
                                                                    return (
                                                                        <option key={i} value={JSON.stringify({
                                                                            months: item.months,
                                                                            free_months: item.free_months
                                                                        })}>{item.months}</option>
                                                                    )
                                                                })
                                                            }
                                                        </select>{" "}{this._renderText("item_3")}
                                                    </div>
                                                    <div className={Styles.optionContainerInnerRightSubtitle}>
                                                        {this._renderText("item_56")} {this._renderNumbers(Math.round(this._renderDiscount()))} {salesChannelRegister.get('currency')}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                    <div className={Styles.summaryContainer}>

                                        <div className={Styles.summaryContainerItem}>
                                            <div className={Styles.summaryContainerItemTitle}>
                                                {this._renderText("item_33")}
                                            </div>
                                            <div className={Styles.summaryContainerItemSummary}>
                                                <div className={Styles.summaryContainerItemSummaryInner}>
                                                    {this._renderText("item_34")}{" "}
                                                    <span className={Styles.summaryContainerItemSummaryBold}>
                                        {
                                            this.state.industry &&
                                            <span>{this.state.industry.name}{" "}</span>
                                        }
                                    </span>
                                                    {this._renderText("item_35")}{" "}
                                                    <span
                                                        className={Styles.summaryContainerItemSummaryBold}>{this.state.duration}{" "}</span>
                                                    {this._renderText("item_36")}
                                                    {' '}
                                                    {this._renderText("item_79")}
                                                    {' '}
                                                    {
                                                        this.state.options === 2 &&
                                                        <span className={Styles.summaryContainerItemSummaryBold}>
                                                        {this._renderText("item_80")}
                                                    </span>
                                                    }
                                                    {
                                                        this.state.options === 1 &&
                                                        <span className={Styles.summaryContainerItemSummaryBold}>
                                                        {this._renderText("item_81")}
                                                    </span>
                                                    }
                                                </div>
                                            </div>
                                            <div
                                                onClick={() => this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/industry")}
                                                className={Styles.summaryContainerItemButton}>
                                                {this._renderText("item_9")}
                                            </div>
                                            <div
                                                onClick={() => this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/industry")}
                                                className={Styles.summaryContainerItemMobileIcon}>
                                                <img className={Styles.summaryContainerItemMobileIconItem}
                                                     src={require("../../assets/images/edit_button_moble.png")}/>
                                            </div>
                                        </div>

                                        <div className={Styles.summaryContainerItem}>
                                            <div className={Styles.summaryContainerItemTitle}>
                                                {this._renderText("item_37")}
                                            </div>
                                            <div className={Styles.summaryContainerItemSummary}>
                                                <div className={Styles.summaryContainerItemSummaryInner}>
                                                    {this._renderText("item_11")}{" "}
                                                    <span className={Styles.summaryContainerItemSummaryBold}>
                                        {
                                            this.state.channels &&
                                            Object.keys(this.state.channels).filter((item) => {
                                                return this.state.channels[item].selected
                                            }).sort((a, b) => this.state.channels[a].index - this.state.channels[b].index).map((key, i) => {
                                                return (
                                                    <span>
                                                          <span
                                                              className={Styles.summaryContainerItemSummaryChannelName}>{this._renderChannelName(key)}</span>
                                                        {
                                                            i !== Object.keys(this.state.channels).filter((item) => {
                                                                return this.state.channels[item].selected
                                                            }).length - 1 &&
                                                            <span>,{" "}</span>
                                                        }
                                                    </span>
                                                )
                                            })
                                        }
                                    </span>
                                                </div>
                                            </div>
                                            <div
                                                onClick={() => this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/ads")}
                                                className={Styles.summaryContainerItemButton}>
                                                {this._renderText("item_9")}
                                            </div>
                                            <div
                                                onClick={() => this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/ads")}
                                                className={Styles.summaryContainerItemMobileIcon}>
                                                <img className={Styles.summaryContainerItemMobileIconItem}
                                                     src={require("../../assets/images/edit_button_moble.png")}/>
                                            </div>
                                        </div>
                                        <div className={Styles.summaryContainerItem}>
                                            <div className={Styles.summaryContainerItemTitle}>
                                                {this._renderText("item_38")}
                                            </div>
                                            <div className={Styles.summaryContainerItemSummary}>
                                                <div className={Styles.summaryContainerItemSummaryInner}>
                                                    {this._renderText("item_13")}{" "}
                                                    <span className={Styles.summaryContainerItemSummaryBold}>
                                        {this._renderAdLanguage()}.{" "}
                                    </span>
                                                    {
                                                        this.state.related.filter((item) => {
                                                            return item.selected
                                                        }).concat(this.state.extra_industries).filter((obj, pos, arr) => {
                                                            return arr.map(mapObj => mapObj["id"]).indexOf(obj["id"]) === pos
                                                        }).length > 0 &&
                                                        <span>{this._renderText("item_14")}{" "}</span>
                                                    }
                                                    <span className={Styles.summaryContainerItemSummaryBold}>
                                        {
                                            this.state.related.filter((item) => {
                                                return item.selected
                                            }).concat(this.state.extra_industries).filter((obj, pos, arr) => {
                                                return arr.map(mapObj => mapObj["id"]).indexOf(obj["id"]) === pos
                                            }).map((prop, key) => {

                                                if (key === this.state.related.filter((item) => {
                                                    return item.selected
                                                }).concat(this.state.extra_industries).filter((obj, pos, arr) => {
                                                    return arr.map(mapObj => mapObj["id"]).indexOf(obj["id"]) === pos
                                                }).length - 1) {
                                                    return (
                                                        <span>{prop.name}</span>
                                                    )
                                                } else {
                                                    return (
                                                        <span>{prop.name},{" "}</span>
                                                    )
                                                }

                                            })
                                        }
                                                        {
                                                            this.state.related.filter((item) => {
                                                                return item.selected
                                                            }).concat(this.state.extra_industries).filter((obj, pos, arr) => {
                                                                return arr.map(mapObj => mapObj["id"]).indexOf(obj["id"]) === pos
                                                            }).length > 0 &&
                                                            <span>.{" "}</span>
                                                        }
                                        </span>
                                                    {this._renderText("item_48")}{" "}
                                                    <span className={Styles.summaryContainerItemSummaryBold}>
                                        {
                                            this.state.regions.map((prop, key) => {
                                                if (key === this.state.regions.length - 1) {
                                                    return (
                                                        <span>{this._renderName(prop)}</span>
                                                    )
                                                } else {
                                                    return (
                                                        <span>{this._renderName(prop)},{" "}</span>
                                                    )
                                                }
                                            })
                                        }
                                        </span>
                                                </div>
                                            </div>
                                            <div
                                                onClick={() => this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/filter")}
                                                className={Styles.summaryContainerItemButton}>
                                                {this._renderText("item_9")}
                                            </div>
                                            <div
                                                onClick={() => this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/filter")}
                                                className={Styles.summaryContainerItemMobileIcon}>
                                                <img className={Styles.summaryContainerItemMobileIconItem}
                                                     src={require("../../assets/images/edit_button_moble.png")}/>
                                            </div>
                                        </div>
                                        {
                                            this.state.targets.filter((item) => {
                                                return item.selected
                                            }).length < 1 &&
                                            this.state.age_range.length < 1 &&
                                            this.state.interests.length < 1 &&
                                            this.state.behaviors.length < 1 &&
                                            this.state.keyword_languages.length < 2 &&
                                            this.state.target_slogans.filter((item) => {
                                                return item.selected
                                            }).length < 1 &&
                                            <div className={Styles.summaryContainerItem}>
                                                <div className={Styles.summaryContainerItemTitle}>
                                                    {this._renderText("item_39")}
                                                </div>
                                                <div className={Styles.summaryContainerItemSummary}>
                                                    <div className={Styles.summaryContainerItemSummaryInner}>
                                                        <div className={Styles.summaryContainerItemSummaryBold}>
                                                            {this._renderText("item_83")}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div
                                                    onClick={() => this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/filter")}
                                                    className={Styles.summaryContainerItemButton}>
                                                    {this._renderText("item_9")}
                                                </div>
                                                <div
                                                    onClick={() => this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/filter")}
                                                    className={Styles.summaryContainerItemMobileIcon}>
                                                    <img className={Styles.summaryContainerItemMobileIconItem}
                                                         src={require("../../assets/images/edit_button_moble.png")}/>
                                                </div>
                                            </div>
                                        }
                                        {
                                            (this.state.plan.type.toLowerCase() === "high") &&
                                            <div className={Styles.summaryContainerItem}>
                                                <div className={Styles.summaryContainerItemTitle}>
                                                    {this._renderText("item_39")}
                                                </div>
                                                <div className={Styles.summaryContainerItemSummary}>
                                                    <div className={Styles.summaryContainerItemSummaryInner}>
                                                        {
                                                            this.state.targets.filter((item) => {
                                                                return item.selected
                                                            }).length > 0 &&
                                                            <span>{this._renderText("item_51")}{" "}</span>
                                                        }
                                                        <span className={Styles.summaryContainerItemSummaryBold}>
                                                {
                                                    this.state.targets.filter((item) => {
                                                        return item.selected
                                                    }).map((item, key) => {
                                                        if (key !== this.state.targets.filter((item) => {
                                                            return item.selected
                                                        }).length - 1) {
                                                            return (
                                                                <span key={key}>{item.title}, </span>
                                                            )
                                                        } else {
                                                            return (
                                                                <span
                                                                    key={key}>{item.title}{this.state.age_range.length < 1 &&
                                                                <span>.</span>}{" "}</span>
                                                            )
                                                        }
                                                    })
                                                }
                                            </span>
                                                        {
                                                            this.state.age_range.length > 0 &&
                                                            <span>{this._renderText("item_40")} <span
                                                                className={Styles.summaryContainerItemSummaryBold}>{this.state.age_range[0]} - {this.state.age_range[1]}</span>.{" "}</span>
                                                        }
                                                        {
                                                            this.state.interests.length > 0 &&
                                                            <span>
                                                        {this._renderText("item_76")}{" "}
                                                                <span className={Styles.summaryContainerItemSummaryBold}>
                                                            {
                                                                this.state.interests.map((prop, key) => {
                                                                    if (key === this.state.interests.length - 1) {
                                                                        return (
                                                                            <span>{prop.name}</span>
                                                                        )
                                                                    } else {
                                                                        return (
                                                                            <span>{prop.name},{" "}</span>
                                                                        )
                                                                    }
                                                                })
                                                            }
                                                                    {
                                                                        this.state.interests.length > 0 &&
                                                                        <span>.{" "}</span>
                                                                    }
                                                        </span>
                                                    </span>
                                                        }
                                                        {
                                                            this.state.behaviors.length > 0 &&
                                                            <span>
                                                        {this._renderText("item_78")}{" "}
                                                                <span className={Styles.summaryContainerItemSummaryBold}>
                                                            {
                                                                this.state.behaviors.map((prop, key) => {
                                                                    if (key === this.state.behaviors.length - 1) {
                                                                        return (
                                                                            <span>{prop.name}</span>
                                                                        )
                                                                    } else {
                                                                        return (
                                                                            <span>{prop.name},{" "}</span>
                                                                        )
                                                                    }
                                                                })
                                                            }
                                                                    {
                                                                        this.state.behaviors.length > 0 &&
                                                                        <span>.{" "}</span>
                                                                    }
                                                        </span>
                                                    </span>
                                                        }
                                                        {
                                                            this.state.keyword_languages.length > 1 &&
                                                            <span>{this._renderText('item_82')}{" "}<span
                                                                className={Styles.summaryContainerItemSummaryBold}>
                                                            {
                                                                this.state.keyword_languages.map((prop, key) => {
                                                                    if (key === this.state.keyword_languages.length - 1) {
                                                                        return (
                                                                            <span>{this.renderKeywordLanguageTitle(prop)}</span>
                                                                        )
                                                                    } else {
                                                                        return (
                                                                            <span>{this.renderKeywordLanguageTitle(prop)},{" "}</span>
                                                                        )
                                                                    }
                                                                })
                                                            }
                                                        </span>.{" "}</span>
                                                        }
                                                        {
                                                            this.state.target_slogans.filter((item) => {
                                                                return item.selected
                                                            }).length > 0 &&
                                                            <span>
                                                        {this._renderText("item_77")}{" "}
                                                                <span className={Styles.summaryContainerItemSummaryBold}>
                                                            {
                                                                this.state.target_slogans.filter((item) => {
                                                                    return item.selected
                                                                }).map((prop, key) => {
                                                                    if (key === this.state.target_slogans.filter((item) => {
                                                                        return item.selected
                                                                    }).length - 1) {
                                                                        return (
                                                                            <span>{prop.slogan.trim()}</span>
                                                                        )
                                                                    } else {
                                                                        return (
                                                                            <span>{prop.slogan.trim()},{" "}</span>
                                                                        )
                                                                    }
                                                                })
                                                            }
                                                                    {
                                                                        this.state.target_slogans.filter((item) => {
                                                                            return item.selected
                                                                        }).length > 0 &&
                                                                        <span>.{" "}</span>
                                                                    }
                                                        </span>
                                                    </span>
                                                        }
                                                    </div>
                                                </div>
                                                <div
                                                    onClick={() => this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/filter")}
                                                    className={Styles.summaryContainerItemButton}>
                                                    {this._renderText("item_9")}
                                                </div>
                                                <div
                                                    onClick={() => this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/filter")}
                                                    className={Styles.summaryContainerItemMobileIcon}>
                                                    <img className={Styles.summaryContainerItemMobileIconItem}
                                                         src={require("../../assets/images/edit_button_moble.png")}/>
                                                </div>
                                            </div>
                                        }
                                        <div className={Styles.summaryContainerItem}>
                                            {
                                                this.state.smart_spend &&
                                                <div className={Styles.summaryContainerItemTitle}>
                                                    {this._renderText("item_41")}
                                                </div>
                                            }
                                            {
                                                this.state.smart_spend &&
                                            <div className={Styles.summaryContainerItemSummary}>
                                                <div className={Styles.summaryContainerItemSummaryInner}>
                                                    {this._renderText("item_49")}{" "}<span className={Styles.summaryContainerItemSummaryBold}>{this._renderTotalBudget()}{" "}{this.state.currency.toUpperCase()}{" "}</span>{this._renderText("item_84")}{" "}{this._renderText("item_40")}{" "}
                                                    {
                                                        this.state.channels &&
                                                        Object.keys(this.state.channels).filter((item) => {
                                                            return this.state.channels[item].selected
                                                        }).sort((a, b) => this.state.channels[a].index - this.state.channels[b].index).map((key, i) => {

                                                            return (
                                                                <span><span className={Styles.summaryContainerItemSummaryChannelName}>{this._renderChannelName(key)}</span>
                                                                    {
                                                                        i !== Object.keys(this.state.channels).filter((item) => {
                                                                            return this.state.channels[item].selected
                                                                        }).length - 1 &&
                                                                        <span>,{" "}</span>
                                                                    }
                                                    </span>
                                                            )
                                                        })
                                                    }
                                                </div>
                                            </div>
                                            }
                                            {
                                                !this.state.smart_spend &&
                                            <div className={Styles.summaryContainerItemTitle}>
                                                {this._renderText("item_41")}
                                            </div>
                                            }
                                            {
                                                !this.state.smart_spend &&
                                            <div className={Styles.summaryContainerItemSummary}>
                                                <div className={Styles.summaryContainerItemSummaryInner}>
                                                    {this._renderText("item_49")}{" "}
                                                    {
                                                        this.state.channels &&
                                                        Object.keys(this.state.channels).filter((item) => {
                                                            return this.state.channels[item].selected
                                                        }).sort((a, b) => this.state.channels[a].index - this.state.channels[b].index).map((key, i) => {

                                                            return (
                                                                <span>
                                                        <span
                                                            className={Styles.summaryContainerItemSummaryBold}>{this._renderNumbers(Math.round(this.state.budget[key].spend))}{" "}{this.state.currency.toUpperCase()}</span>
                                                        <span>&nbsp;{this._renderText("item_50")}{" "}<span
                                                            className={Styles.summaryContainerItemSummaryChannelName}>{this._renderChannelName(key)}</span></span>
                                                                    {
                                                                        i !== Object.keys(this.state.channels).filter((item) => {
                                                                            return this.state.channels[item].selected
                                                                        }).length - 1 &&
                                                                        <span>,{" "}</span>
                                                                    }
                                                    </span>
                                                            )
                                                        })
                                                    }
                                                </div>
                                            </div>
                                            }
                                            <div
                                                onClick={() => this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/budget")}
                                                className={Styles.summaryContainerItemButton}>
                                                {this._renderText("item_9")}
                                            </div>
                                            <div
                                                onClick={() => this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/budget")}
                                                className={Styles.summaryContainerItemMobileIcon}>
                                                <img className={Styles.summaryContainerItemMobileIconItem}
                                                     src={require("../../assets/images/edit_button_moble.png")}/>
                                            </div>
                                        </div>
                                        {
                                            this._renderPromoPage() &&
                                            <span>
                                            <div onClick={() => {
                                                this.state.accordions.one = this.state.accordions.one === 0 ? 'auto' : 0;
                                                this.setState({accordions: this.state.accordions})
                                            }}
                                                 className={cx(Styles.summaryContainerItem, Styles.summaryContainerItemLast)}>
                                        <div
                                            className={cx(Styles.summaryContainerItemTitle, Styles.summaryContainerItemTitleLarge)}>
                                            +
                                        </div>
                                        <div className={Styles.summaryContainerItemSummary}>
                                            <div className={Styles.summaryContainerItemSummaryInner}>
                                                <span
                                                    className={Styles.summaryContainerItemSummaryBold}>
                                                {this._renderText("item_73")}
                                            </span>
                                            </div>
                                        </div>
                                        <div className={cx(Styles.summaryContainerItemButton)}>
                                            {this._renderText("item_9")}
                                        </div>
                                        <div
                                            className={Styles.summaryContainerItemMobileIcon}>
                                            <img className={Styles.summaryContainerItemMobileIconItem}
                                                 src={require("../../assets/images/edit_button_moble.png")}/>
                                        </div>
                                    </div>
                                    <AnimateHeight duration={100}
                                                   height={this.state.accordions.one}>
                                        {
                                            <div
                                                className={cx(Styles.summaryContainerItem, Styles.summaryContainerItemPromo, Styles.summaryContainerItemSalesPitch)}>
                                                {
                                                    <div className={Styles.inputDivider}>
                                                        <div className={Styles.inputDividerItem}>
                                                            <div className={Styles.inputDividerItemInner}>
                                                                <div className={Styles.inputDividerItemInnerDropdown}>
                                                                    <input
                                                                        placeholder={this._renderText("item_75")}
                                                                        type="tel"
                                                                        onFocus={() => this.setState({dropdown_one: true})}
                                                                        onBlur={() => this.setState({dropdown_one: false})}
                                                                        value={this.state.search}
                                                                        onChange={(event) => this.setState({search: event.target.value})}
                                                                        className={Styles.inputDividerItemInnerDropdownInput}
                                                                    />
                                                                    {
                                                                        this.state.dropdown_one && this.state.countries.filter((item) => {
                                                                            return item.dialCode.toLowerCase().indexOf(this.state.search.toLowerCase()) !== -1
                                                                        }).length > 0 &&
                                                                        <div className={Styles.dropdownList}>
                                                                            {
                                                                                this.state.countries.filter((item) => {
                                                                                    return item.dialCode.toLowerCase().indexOf(this.state.search.toLowerCase()) !== -1
                                                                                }).map((prop, key) => {
                                                                                    return (
                                                                                        <div key={key}
                                                                                             onMouseDown={() => this._selectCountry(prop)}
                                                                                             className={Styles.dropdownListItem}>
                                                                                            {prop.dialCode}
                                                                                        </div>
                                                                                    )
                                                                                })
                                                                            }
                                                                        </div>
                                                                    }
                                                                </div>
                                                                <div className={Styles.inputDividerItemInnerInput}>
                                                                    <input
                                                                        type="tel"
                                                                        value={this.state.promo_phone}
                                                                        onChange={(event) => this.setState({promo_phone: event.target.value})}
                                                                        className={Styles.input}
                                                                        placeholder={this._renderText("item_67")}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {
                                                            <div className={Styles.inputDividerItem}>
                                                                <div className={Styles.checkMarksContainerItem}>
                                                                    {
                                                                        !this.state.whatsapp &&
                                                                        <img
                                                                            onClick={() => this.setState({whatsapp: true})}
                                                                            src={require("../../assets/images/square_checkmark_two.svg")}
                                                                            className={Styles.checkMarksContainerItemIcon}/>
                                                                    }
                                                                    {
                                                                        this.state.whatsapp &&
                                                                        <img
                                                                            onClick={() => this.setState({whatsapp: false})}
                                                                            src={require("../../assets/images/square_checkmark_active.svg")}
                                                                            className={Styles.checkMarksContainerItemIcon}/>
                                                                    }
                                                                    <img
                                                                        className={Styles.checkMarksContainerItemWhatsapp}
                                                                        src={require("../../assets/images/whatsapp.png")}/>
                                                                </div>
                                                            </div>
                                                        }
                                                    </div>
                                                }

                                                <div onClick={() => this._promopage(false)}
                                                     className={cx(Styles.buttonBlack)}>
                                                    {this._renderText("item_65")}
                                                </div>

                                            </div>
                                        }
                                    </AnimateHeight>
                                    <div className={Styles.border}></div>
                                    <div onClick={() => {
                                        this.state.accordions.two = this.state.accordions.two === 0 ? 'auto' : 0;
                                        this.setState({accordions: this.state.accordions})
                                    }} className={cx(Styles.summaryContainerItem, Styles.summaryContainerItemLast)}>
                                        <div
                                            className={cx(Styles.summaryContainerItemTitle, Styles.summaryContainerItemTitleLarge)}>
                                            +
                                        </div>
                                        <div className={Styles.summaryContainerItemSummary}>
                                            <div className={Styles.summaryContainerItemSummaryInner}>
                                                 <span className={Styles.summaryContainerItemSummaryBold}>
                                                 {this._renderText("item_74")}
                                            </span>
                                            </div>
                                        </div>
                                        <div
                                            className={cx(Styles.summaryContainerItemButton)}>
                                            {this._renderText("item_9")}
                                        </div>
                                        <div className={Styles.summaryContainerItemMobileIcon}>
                                            <img className={Styles.summaryContainerItemMobileIconItem}
                                                 src={require("../../assets/images/edit_button_moble.png")}/>
                                        </div>
                                    </div>
                                    <AnimateHeight duration={100}
                                                   height={this.state.accordions.two}>
                                        {
                                            <div
                                                className={cx(Styles.summaryContainerItem, Styles.summaryContainerItemPromo, Styles.summaryContainerItemSalesPitch)}>
                                                <div className={Styles.inputDivider}>
                                                    <div className={Styles.inputDividerItem}>
                                                        <div className={Styles.inputDividerItemInner}>
                                                            <div className={Styles.inputDividerItemInnerDropdown}>
                                                                <input
                                                                    type="tel"
                                                                    placeholder={this._renderText("item_75")}
                                                                    onFocus={() => this.setState({dropdown_two: true})}
                                                                    onBlur={() => this.setState({dropdown_two: false})}
                                                                    value={this.state.search}
                                                                    onChange={(event) => this.setState({search: event.target.value})}
                                                                    className={Styles.inputDividerItemInnerDropdownInput}
                                                                />
                                                                {
                                                                    this.state.dropdown_two && this.state.countries.filter((item) => {
                                                                        return item.dialCode.toLowerCase().indexOf(this.state.search.toLowerCase()) !== -1
                                                                    }).length > 0 &&
                                                                    <div className={Styles.dropdownList}>
                                                                        {
                                                                            this.state.countries.filter((item) => {
                                                                                return item.dialCode.toLowerCase().indexOf(this.state.search.toLowerCase()) !== -1
                                                                            }).map((prop, key) => {
                                                                                return (
                                                                                    <div key={key}
                                                                                         onMouseDown={() => this._selectCountry(prop)}
                                                                                         className={Styles.dropdownListItem}>
                                                                                        {prop.dialCode}
                                                                                    </div>
                                                                                )
                                                                            })
                                                                        }
                                                                    </div>
                                                                }
                                                            </div>
                                                            <div className={Styles.inputDividerItemInnerInput}>
                                                                <input
                                                                    type="tel"
                                                                    value={this.state.promo_phone_2}
                                                                    onChange={(event) => this.setState({promo_phone_2: event.target.value})}
                                                                    className={Styles.input}
                                                                    placeholder={this._renderText("item_67")}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {
                                                        <div className={Styles.inputDividerItem}>
                                                            <div className={Styles.checkMarksContainerItem}>
                                                                {
                                                                    !this.state.whatsapp_2 &&
                                                                    <img
                                                                        onClick={() => this.setState({whatsapp_2: true})}
                                                                        src={require("../../assets/images/square_checkmark_two.svg")}
                                                                        className={Styles.checkMarksContainerItemIcon}/>
                                                                }
                                                                {
                                                                    this.state.whatsapp_2 &&
                                                                    <img
                                                                        onClick={() => this.setState({whatsapp_2: false})}
                                                                        src={require("../../assets/images/square_checkmark_active.svg")}
                                                                        className={Styles.checkMarksContainerItemIcon}/>
                                                                }
                                                                <img

                                                                    className={Styles.checkMarksContainerItemWhatsapp}
                                                                    src={require("../../assets/images/whatsapp.png")}/>
                                                            </div>
                                                        </div>
                                                    }
                                                </div>
                                                <div className={Styles.inputDivider}>
                                                    <div className={Styles.inputDividerItem}>
                                                        <input
                                                            value={this.state.seller_name}
                                                            onChange={(event) => this.setState({seller_name: event.target.value})}
                                                            className={Styles.input}
                                                            placeholder={this._renderText("item_69")}
                                                        />
                                                    </div>
                                                </div>
                                                <div className={Styles.inputDivider}>
                                                    <div className={Styles.inputDividerItem}>
                                                        <input
                                                            value={this.state.job_title}
                                                            onChange={(event) => this.setState({job_title: event.target.value})}
                                                            className={Styles.input}
                                                            placeholder={this._renderText("item_70")}
                                                        />
                                                    </div>
                                                </div>

                                                <div onClick={() => this._promopage(true)}
                                                     className={cx(Styles.buttonBlack)}>
                                                    {this._renderText("item_68")}
                                                </div>

                                            </div>
                                        }
                                    </AnimateHeight>
                                    <div className={Styles.border}></div>
                                        </span>
                                        }
                                    </div>
                                    <div className={Styles.contentContainer}>
                                        {
                                            Object.keys(this.state.channels).filter((item) => {
                                                return this.state.channels[item].selected
                                            }).sort((a, b) => this.state.channels[a].index > this.state.channels[b].index).map((key, i) => {
                                                return (
                                                    <div key={i} className={Styles.contentContainerItem}>
                                                        <div className={Styles.contentContainerItemUpper}>
                                                            <div className={Styles.contentContainerItemUpperLeft}>
                                                                {this._renderChannelName(key).toUpperCase()}
                                                            </div>
                                                            <div className={Styles.contentContainerItemUpperRight}>
                                                                &nbsp;{(!this.state.service_fee_percentage && !this.state.service_fee_fixed && this.state.lockin) &&
                                                            <span
                                                                className={Styles.lockin}>{this.state.lockin_plan.months}{" "}X{" "}</span>}
                                                                {this._renderNumbers(Math.round(this.state.budget[key].spend))}{" "}{this.state.currency.toUpperCase()}
                                                            </div>
                                                        </div>
                                                        <div className={Styles.contentContainerItemLower}>
                                                            <div className={Styles.contentContainerItemLowerLeft}>
                                                                {Math.floor(this.state.budget[key].spend / this.state.duration)}{" "}{this.state.currency.toLowerCase()}{" "}/{" "}{this._renderText("item_44")}
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            })
                                        }
                                        {
                                            (this.state.service_fee_fixed || this.state.service_fee_percentage) &&
                                            <div className={Styles.contentContainerItem}>
                                                <div className={Styles.contentContainerItemUpper}>
                                                    <div className={Styles.contentContainerItemUpperLeft}>
                                                        {this._renderText("item_45")}
                                                    </div>
                                                    <div className={Styles.contentContainerItemUpperRight}>
                                                        {
                                                            this.state.service_fee_fixed &&
                                                            <span>{this._renderNumbers(this._renderFixedFee())}{" "}{this.state.currency.toUpperCase()}</span>
                                                        }
                                                        {
                                                            this.state.service_fee_percentage &&
                                                            <div className={Styles.contentContainerItemUpperRight}>
                                                                {this._renderNumbers(Math.round(this._renderPercentageFee()))}{" "}{this.state.currency.toUpperCase()}
                                                            </div>
                                                        }
                                                    </div>
                                                </div>
                                                {
                                                    <div className={Styles.contentContainerItemLower}>
                                                        {
                                                            (this.state.service_fee_fixed || this.state.service_fee_percentage) && !this.state.lockin &&
                                                            <div className={Styles.contentContainerItemLowerLeftService}>
                                                                {this.state.plan.title[langRegister.lang()]}
                                                            </div>
                                                        }
                                                        {
                                                            this.state.lockin &&
                                                            <div className={Styles.contentContainerItemLowerLeftService}>
                                                                {this._renderText("item_63")}{" "}{this.state.lockin_plan.months}
                                                            </div>
                                                        }
                                                        {
                                                            this.state.lockin &&
                                                            <div className={Styles.contentContainerItemLowerRightService}>
                                                                {this._renderDiscount() > 0 &&
                                                                <span>-</span>}{this._renderNumbers(Math.round(this._renderDiscount()))}{" "}{this.state.currency.toUpperCase()}
                                                            </div>
                                                        }
                                                    </div>
                                                }
                                            </div>
                                        }
                                        {
                                            (!this.state.service_fee_fixed && !this.state.service_fee_percentage && this.state.lockin) &&
                                            <div className={Styles.channelsContainerItem}>
                                                <div className={Styles.channelsContainerItemTop}>
                                                    <div
                                                        className={cx(Styles.channelsContainerItemTopTitle, Styles.channelsContainerItemTopTitleGreen)}>
                                                        {this._renderText("item_64")}
                                                    </div>
                                                    <div
                                                        className={cx(Styles.channelsContainerItemTopPrice, Styles.channelsContainerItemTopTitleGreen)}>
                                                        {this._renderDiscount() > 0 &&
                                                        <span>-</span>}{this._renderNumbers(Math.round(this._renderDiscount()))}{" "}{this.state.currency}
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                    <div className={Styles.dividerSmall}/>
                                    <div className={Styles.vatContainerMobile}>
                                        <div className={Styles.vatContainerLeft}>
                                            {this._renderText("item_27")}{" "}({+this.state.vat}%)
                                        </div>
                                        <div className={Styles.vatContainerRight}>
                                            {this._renderNumbers(this._renderVat())}{" "}{this.state.currency.toUpperCase()}
                                        </div>
                                    </div>
                                    <div className={Styles.dividerSmall}/>
                                    <div className={Styles.totalContainer}>
                                        <div className={Styles.totalContainerLeft}>
                                            {this._renderText("item_28")}
                                        </div>
                                        <div className={Styles.totalContainerRight}>
                                            {this._renderNumbers(this._renderPartialBudget())}{" "}{this.state.currency.toUpperCase()}
                                        </div>
                                    </div>
                                    <div onClick={() => this._payment()} className={
                                        cx(Styles.button,
                                            {
                                                [Styles.buttonShortLinkActive]: false
                                            })
                                    }>
                                        {this._renderText("item_19")}
                                        <span className={Styles.mobileButtonPrice}>
                                        {this._renderNumbers(this._renderPartialBudget())}{" "}{this.state.currency.toLowerCase()}
                                    </span>
                                    </div>
                                    <div className={Styles.underButton}>
                                        <div
                                            onClick={() => this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/budget")}
                                            className={Styles.backButton} style={salesChannelRegister.get('name')==='yieldlock'?{color: '#00273A'}:{}}>
                                            {this._renderText("item_32")}
                                        </div>
                                        <div style={salesChannelRegister.get('name')==='yieldlock'?{color: '#00273A'}:{}} onClick={() => this._terms()} className={Styles.terms}>
                                            {this._renderText("item_55")}
                                        </div>
                                    </div>
                                    <div className={Styles.tabsContainer}>
                                        <div onClick={() => this._selectTab("expect")} className={
                                            cx(Styles.tabsContainerItem,
                                                {
                                                    [Styles.tabsContainerItemActive]: this.state.tab === "expect",
                                                })
                                        }>
                                            {this._renderText("item_30")}
                                        </div>
                                        <div onClick={() => this._selectTab("policy")} className={
                                            cx(Styles.tabsContainerItem,
                                                {
                                                    [Styles.tabsContainerItemActive]: this.state.tab === "policy",
                                                })
                                        }>
                                            {this._renderText("item_31")}
                                        </div>
                                    </div>
                                    <div className={Styles.tabsContent}>
                                        {
                                            this.state.tab === "expect" &&
                                            <div>
                                                {this._renderText("item_53")}
                                            </div>
                                        }
                                        {
                                            this.state.tab === "policy" &&
                                            <div>
                                                {this._renderText("item_54")}
                                            </div>
                                        }
                                    </div>
                                </div>
                                <div className={Styles.right}>
                                    {
                                        this._renderSelectedChannels() &&
                                        <div className={Styles.contentContainerRightInner}>
                                            <Basket lockin_plan={this.state.lockin_plan} lockin={this.state.lockin}
                                                    updateBudget={this._updateBudget} props={this.props}
                                                    nextView={"/signup/payment"} regions={["1"]}
                                                    serviceFeeFixed={this.state.service_fee_fixed}
                                                    regions={this.state.regions}
                                                    serviceFeePercentage={this.state.service_fee_percentage}
                                                    budget={this.state.budget} channels={this.state.channels}
                                                    currency={this.state.currency} plan={this.state.plan}
                                                    vat={+this.state.vat} duration={this.state.duration}/>
                                            <div
                                                onClick={() => this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/payment")}
                                                className={
                                                    cx(Styles.contentContainerRightButton,
                                                        {
                                                            [Styles.buttonActive]: this._renderSelectedChannels()
                                                        })
                                                }>
                                                {this._renderText("item_60")}
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                }
                {
                    this.state.error &&
                    <div className={Styles.loader}>
                        <ErrorHandler props={this.props}/>
                    </div>
                }
            </div>
        );
    }
}

export default BoosterCheckout;


// WEBPACK FOOTER //
// ./src/pages/booster-checkout/component.js